<ng-container *transloco="let t; read: i18nScope">
  <div *ngIf="displayUploadPlaceholder$ | async" class="upload-placeholder">
    <span *ngIf="!videoId">{{  t('media.video.uploadPlaceholder') }}</span>

    <lib-relative-loader *ngIf="videoId"></lib-relative-loader>
  </div>
</ng-container>

<!-- Transparent overlay to intercept inner iframe clicks -->
<!-- Thumbnail overlay to hide Youtube video not playing state view. It is black until thumbnail image loads -->
<div
  class="overlay"
  [class.thumbnail-overlay]="(displayThumbnailOverlay$ | async)"
  [class.with-upload-placeholder]="displayUploadPlaceholder">
  <ng-container *ngIf="(thumbnailImageInfo$ | async) as thumbnailImageInfo">
    <img
      *ngIf="thumbnailImageInfo.url"
      alt=""
      [src]="thumbnailImageInfo.url"
      (load)="onThumbnailImageLoad()">

  </ng-container>
</div>

<div #player [id]="playerId"></div>
